module.exports = __webpack_public_path__ + "img/icon-file-csv-blue.dd76ebeb.svg";